import { render, staticRenderFns } from "./Locality.vue?vue&type=template&id=e81aa89c&scoped=true"
import script from "./Locality.vue?vue&type=script&lang=js"
export * from "./Locality.vue?vue&type=script&lang=js"
import style0 from "./Locality.vue?vue&type=style&index=0&id=e81aa89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81aa89c",
  null
  
)

export default component.exports